import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {StoreTreeComponent} from '@app/4dm1n/store-tree/store-tree.component';
import {DxPopupModule} from 'devextreme-angular';

@Component({
  selector: 'app-display-store-tree-popup',
  imports: [CommonModule, StoreTreeComponent, DxPopupModule],
  templateUrl: './display-store-tree-popup.component.html',
  standalone: true,
  styleUrls: ['./display-store-tree-popup.component.scss']
})
export class DisplayStoreTreePopupComponent {

}
